import { render, staticRenderFns } from "./ParserContent.vue?vue&type=template&id=704af8c8&scoped=true"
import script from "./ParserContent.vue?vue&type=script&lang=js"
export * from "./ParserContent.vue?vue&type=script&lang=js"
import style0 from "./ParserContent.vue?vue&type=style&index=0&id=704af8c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704af8c8",
  null
  
)

export default component.exports